import { render, staticRenderFns } from "./MenuCommunComponent.vue?vue&type=template&id=5f4e0a41"
import script from "./MenuCommunComponent.vue?vue&type=script&lang=js"
export * from "./MenuCommunComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports